import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { E11TooltipModule } from '@engineering11/ui-lib/e11-tooltip'

@Component({
  selector: 'pattern-traits-list-wrapper',
  imports: [E11TooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  template: `
    <div class="e11-flex e11-flex-wrap e11-gap-2 e11-w-full e11-group/pattern-category">
      <ng-content></ng-content>
      @if (tooltipText()) {
      <div class="group-hover/pattern-category:e11-block group-hover/pattern-category:e11-opacity-100 e11-hidden e11-opacity-0 e11-transition-all">
        <e11-tooltip [tooltipText]="tooltipText()" [color]="'dark-grey'" placement="top">
          <span [style.color]="iconColor()" class="material-icons-outlined md-14 e11-mr-1">info</span>
        </e11-tooltip>
      </div>
      }
    </div>
  `,
})
export class PatternTraitsListWrapperComponent {
  iconColor = input<string>()
  tooltipText = input<string>()
}
